var React = require('react');

function Sheets (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#0DC54C;}\n\t.st1{fill:#08962D;}\n\t.st2{fill:#FDFFFF;}\n"),React.createElement("g",{"id":"Layer_4","key":1},[React.createElement("path",{"className":"st0","d":"M58,88H6c-3.3,0-6-2.7-6-6V6c0-3.3,2.7-6,6-6h36l22,22v60C64,85.3,61.3,88,58,88z","key":0}),React.createElement("path",{"className":"st1","d":"M42,0l22,22H42V0z","key":1}),React.createElement("path",{"className":"st2","d":"M12,34.5v28h40v-28H12z M17,39.5h12.5V46H17V39.5z M17,51h12.5v6.5H17V51z M47,57.5H34.5V51H47V57.5z M47,46\n\t\tH34.5v-6.5H47V46z","key":2})])]);
}

Sheets.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 64 88","style":{"enableBackground":"new 0 0 64 88"},"xmlSpace":"preserve"};

module.exports = Sheets;

Sheets.default = Sheets;
